import * as React from 'react';
import {FunctionComponent} from 'react';
import {BarChart} from '../BarChart';
import {PartialWorkout} from '../../../../Models/PartialWorkout';
import {DateRange} from '../../../../Domain/DateRange';
import {Distance} from '../../../../Domain/Distance';
import {format, isSameMonth} from 'date-fns';

interface OwnProps {
    dateRange: DateRange;
    partialWorkouts: PartialWorkout[];
}

export const MonthlySummaryBarChart: FunctionComponent<OwnProps> = ({dateRange, partialWorkouts}) => {
    if (dateRange.from === null || dateRange.till === null) {
        return null;
    }

    //Create groups based on the date range
    const groups: Array<{date: Date; partialWorkouts: PartialWorkout[]}> = [];
    for (
        let date = dateRange.from;
        date <= dateRange.till;
        date = new Date(date.getFullYear(), date.getMonth() + 1, 1)
    ) {
        groups.push({
            date,
            partialWorkouts: [],
        });
    }

    //Add the partial workouts to the groups
    partialWorkouts.forEach((partialWorkout) => {
        const group = groups.find((g) => isSameMonth(g.date, partialWorkout.executed_at));
        if (group) {
            group.partialWorkouts.push(partialWorkout);
        }
    }, []);

    const values = groups.map((group) => {
        return {
            x: group.date.getTime(),
            y: group.partialWorkouts.reduce((totalSum, partialWorkout) => {
                return totalSum.add(
                    partialWorkout.workout_part_results.reduce((workoutSum, result) => {
                        return workoutSum.add(result.traveled_distance);
                    }, Distance.fromMillimeters(0)),
                );
            }, Distance.fromMillimeters(9)).kilometers,
        };
    });

    // Create axis labels
    const axis = {
        x: groups.map((group) => {
            return {
                value: group.date.getTime(),
                label: format(group.date, 'MMM yy'),
            };
        }),
    };

    return <BarChart values={values} axis={axis} />;
};
